import * as React from "react";

function SvgBuzzBoard(props, ref) {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 465.14 513.22"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        d="M465.14 206.67c0-57.07-22.83-105.17-68.07-145.93C351.41 20.38 296.78 0 232.77 0c-64.41 0-119.44 20.38-164.3 60.74C22.86 101.5 0 149.61 0 206.67c0 57.48 22.86 106 68.47 146.35 34.68 31.39 75 50.14 120.68 57.49l102.73 102.71V407.61c39.14-9.36 74.59-27.3 105.19-54.62 45.24-40.33 68.07-88.84 68.07-146.32zm-67.27-22.83a110 110 0 012 22.83c0 39.95-16.31 74.61-48.93 102.32-32.61 28.14-71.75 42.4-118.21 42.4-46.06 0-85.6-14.26-118.22-42.4-32.61-27.71-48.92-62.37-48.92-102.32s16.35-74.19 48.98-102.32A153.48 153.48 0 01163.5 75c1.62 35.06 16.31 65.23 44.44 90.1 20.37 17.93 43.6 30.16 69.69 35.87v70.11L344.9 203c19.55-3.25 37.08-9.39 52.97-19.16zm-46.89-79.49a148.2 148.2 0 0133 39.55c-19.17 13.45-42 20-67.67 20-30.57 0-56.67-9.38-77.88-28.53-21.59-18.35-32.62-40.77-32.62-67.27v-3.67a205.58 205.58 0 0126.92-2c46.5-.06 85.64 13.8 118.25 41.92z"
        fill="#5ab854"
      />
    </svg>
  );
}

export default React.forwardRef(SvgBuzzBoard);
